<template>

  <div id="edit-product">

    <div v-if="product" class="p-4">
      <product-details :product="product" @productUpdated="fetchProduct" @refreshProduct="fetchProduct"/>
    </div>


  </div>
</template>


<script>
import ProductDetails from "@/components/ProductDetails";
export default{

  components: {ProductDetails},

  mounted(){
    this.fetchProduct();

  },

  methods:{
    fetchProduct(){
      this.axios.get('/admin/products/'+ this.$route.params.itemId).then(res=>{
        this.product = {...res.data, };

      }).catch(()=>{
        this.$notify({type: 'error', title:'Something went wrong', text: 'Please try again later!'});
      })
    }
  },
  data(){
    return{
      product: null
    }
  }

}
</script>